import type { AgentTemplateGrant } from '@reach/shared-types/agent-templates';

export type AgentTemplateGrantTarget = { toolDefinitionId: string } | { systemToolName: string };

type AgentTemplateGrantKeySource = AgentTemplateGrantTarget | AgentTemplateGrant | { grantId: string };

export function buildAgentTemplateGrantKey(
  templateId: string,
  source: AgentTemplateGrantKeySource,
): string {
  if ('toolDefinitionId' in source && source.toolDefinitionId) {
    return `${templateId}:tool:${source.toolDefinitionId}`;
  }
  if ('systemToolName' in source && source.systemToolName) {
    return `${templateId}:system:${source.systemToolName}`;
  }
  if ('grantId' in source) {
    return `${templateId}:grant:${source.grantId}`;
  }
  throw new Error('A template grant key requires a tool or system tool identifier');
}
